export const states = ["CT", "MA", "RI", "VT", "NH", "NY"]